import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, LayoutGrid, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import LoginSidebarWrapper from '../pages/LoginSidebarWrapper';
import AccountSidebar from './AccountSidebar';

const Footer = () => {
  const { user, isAdmin } = useAuth();
  const { cartCount } = useCart();

  const shopLink = isAdmin ? '/admin' : '/store';

  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);

  const openLoginSidebar = (e) => {
    e.preventDefault();
    setIsLoginOpen(true);
  };

  const closeLoginSidebar = () => setIsLoginOpen(false);
  const openAccountSidebar = () => setIsAccountOpen(true);
  const closeAccountSidebar = () => setIsAccountOpen(false);

  return (
    <>
      <footer className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200/70 bg-white/90 backdrop-blur-xl shadow-[0_-8px_30px_-16px_rgba(15,23,42,0.2)]">
        <nav className="mx-auto max-w-7xl px-3">
          <ul className="flex h-14 items-center justify-around text-slate-600">
            <li>
              <Link to={shopLink} className="flex flex-col items-center justify-center rounded-xl px-2 py-1 font-medium transition hover:text-purple-600">
                <ShoppingCart size={19} />
                <span className="mt-1 text-[11px]">Shop</span>
              </Link>
            </li>

            <li>
              <Link to="/zones" className="flex flex-col items-center justify-center rounded-xl px-2 py-1 text-sm transition hover:text-purple-600">
                <LayoutGrid size={19} />
                <span className="mt-1 text-[11px]">Zones</span>
              </Link>
            </li>

            <li className="relative">
              <Link to="/cart" className="flex flex-col items-center justify-center rounded-xl px-2 py-1 text-sm transition hover:text-purple-600">
                <ShoppingCart size={19} />
                <span className="mt-1 text-[11px]">Cart</span>
              </Link>
              {cartCount > 0 && (
                <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-purple-600 text-[10px] font-bold text-white">
                  {cartCount}
                </span>
              )}
            </li>

            <li>
              {user ? (
                <button onClick={openAccountSidebar} className="flex flex-col items-center justify-center rounded-xl px-2 py-1 text-sm transition hover:text-purple-600 focus:outline-none">
                  <User size={19} />
                  <span className="mt-1 text-[11px]">Account</span>
                </button>
              ) : (
                <a href="#" onClick={openLoginSidebar} className="flex flex-col items-center justify-center rounded-xl px-2 py-1 text-sm transition hover:text-purple-600">
                  <User size={19} />
                  <span className="mt-1 text-[11px]">Account</span>
                </a>
              )}
            </li>
          </ul>
        </nav>
      </footer>

      <LoginSidebarWrapper isOpen={isLoginOpen} onClose={closeLoginSidebar} />
      <AccountSidebar isOpen={isAccountOpen} onClose={closeAccountSidebar} />
    </>
  );
};

export default Footer;
